export default "__VITE_ASSET__044ddcb5__"